export default __webpack_public_path__ + "static/media/BOProto4.8e17bef7.png";